import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Menu from '../components/Menu';
import Logs from '../components/dashboard/Logs';
import api from '../utils/apiClient';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PAGE = 50;

// Журнал действий по асикам: настоящие записи (GET logs/device) в пределах прав роли.
// Раньше страница показывала демонстрационные записи, зашитые в код.
const LogsList = () => {
  const theme = useTheme();
  const { t } = useTranslation('dashboard');
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [failedOffset, setFailedOffset] = useState(null);

  const load = useCallback(async (offset) => {
    setLoading(true);
    setFailedOffset(null);
    try {
      const resp = await api.get(`${API_BASE_URL}logs/device`, { params: { limit: PAGE, offset } });
      if (!Array.isArray(resp?.data?.logs)) throw new Error('Invalid journal response');
      const list = resp.data.logs;
      setLogs((prev) => (offset > 0 ? [...prev, ...list] : list));
      setHasMore(typeof resp?.data?.has_more === 'boolean' ? resp.data.has_more : list.length === PAGE);
    } catch (e) {
      // Keep the successful pages and retry the failed page at its original offset.
      setFailedOffset(offset);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(0); }, [load]);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: theme.palette.background.default }}>
      <Menu hideRefresh />
      <Box sx={{ maxWidth: 1200, mx: 'auto', px: 2, py: 3 }}>
        {failedOffset !== null && (
          <Alert severity="error" sx={{ mb: 2 }} action={
            <Button color="inherit" size="small" onClick={() => load(failedOffset)} disabled={loading}>
              {t('logsRetry')}
            </Button>
          }>
            {t('logsLoadError')}
          </Alert>
        )}
        {logs.length > 0 || (!loading && failedOffset === null) ? (
          <Logs logsData={{ logs, loading, onLoadMore: () => load(logs.length), canLoadMore: hasMore && failedOffset === null }} />
        ) : loading ? (
          <Typography role="status">{t('logsLoading')}</Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default LogsList;
